import styles from './MetropoleMuseeFabreHeader.module.css'
import doubleLogoMuseeFabre from '../../../../assets/images/double_logo_musee_fabre_3m.png'

const MetropoleMuseeFabreHeader = () => (
  <header className={styles.header}>
    <img
      className={styles.logo}
      src={doubleLogoMuseeFabre}
      alt="Musée Fabre – Montpellier Méditerranée Métropole"
    />
  </header>
)

export default MetropoleMuseeFabreHeader
